import { AllureYearlyPlanStateTypes, AllureYearlyPlanActionTypes } from "./AllureYearlyPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureYearlyPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureYearlyPlanReducer = (
  state: AllureYearlyPlanStateTypes = INITIAL_STATE,
  action: any
): AllureYearlyPlanStateTypes => {
  switch (action.type) {
    case AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureYearlyPlanReducer;
